import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
 
import {
  fetchDoctors,
  fetchPatients,
  fetchAnalytics,
  fetchAnalyticsforadmin,
} from "../Actions";
import WeeklyRiskTrend from "./graphs/WeeklyRiskTrend";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import doctorbox from "../Assets/images/admindashboard/doctorbox.svg";
import medicalfile from "../Assets/images/admindashboard/medicalfile.svg";
import assessmentsImg from "../Assets/images/dashboard/doctor.svg";
import virusImg from "../Assets/images/dashboard/virus.svg";
import {
  ShimmerThumbnail,
  ShimmerButton,
} from "react-shimmer-effects";
import axios from "../axios";
import * as moment from "moment";
import Popup from "./Popup";
 
const AdminDashboard = (props) => {
  var count = 0;
  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  const oneWeekFromToday = new Date();
  oneWeekFromToday.setDate(today.getDate() + 7);
  const oneWeek =
    oneWeekFromToday.getFullYear() +
    "-" +
    (oneWeekFromToday.getMonth() + 1) +
    "-" +
    oneWeekFromToday.getDate();
  const [loading, setLoading] = useState(false);
  const [yesterdayAssessments, setYesterdayAssessments] = useState(0);
  const [endDate, setEndDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [total_patients, setTotal_patients] = useState();
  const [total_assessments, setTotal_assessments] = useState();
  const [total_doctors, setTotal_doctors] = useState();
  const [highRiskCount, setHighRiskCount] = useState();
  const [activeFilter, setActiveFilter] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setShowPopup(true);
  }, []);

 

 
  useEffect(() => {
    getTotalCountApi();
    // props.fetchDoctors().then(() => setLoading(false));
    // props.fetchPatients("", "").then(() => setLoading(false));
    props.fetchAnalyticsforadmin(oneWeek, date).then();
    fetchYesterdayCountApi();
  }, []);
 
  const closePopup = () => {
    setShowPopup(false);
  };

 
  const fetchYesterdayCountApi = async () => {
    try {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const yesterdayDate = yesterday.toISOString().slice(0, 10);
 
      await axios
        .get(
          `getPatientsAssessments?created_on_start=${yesterdayDate} 00:00:00&created_on_end=${yesterdayDate} 23:59:59`,
 
          {
            headers: { accessToken: localStorage.accessToken },
          }
        )
        .then((response) => {
          console.log(response.data.data.assessment_count);
          setYesterdayAssessments(response.data.data.assessment_count);
          console.log(yesterdayAssessments);
        })
        .catch((error) => {
          console.log("error", error);
        });
    } catch (e) {
      console.log(e);
    }
  };
 
  const getTotalCountApi = () => {
    setLoading(true);
    setStartDate("");
    setEndDate("");
  
    axios
      .get(`v2/admin/total_count?userId=${encodeURIComponent(localStorage.doctorId)}&lhi=high`, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((response) => {
        
        if (response.data.message) {
          console.log(response.data.message);
          setTotal_doctors(0);
          setTotal_assessments(0);
          setTotal_patients(0);
          setHighRiskCount(0);
        } else {
          setTotal_doctors(response.data.data.doc_count);
          setTotal_assessments(response.data.data.total_assessments);
          setTotal_patients(response.data.data.patients_count);
          setHighRiskCount(response.data.data.high_risk_patients);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false); // Ensure loading is stopped even in case of an error
      });
  };
  
 
  const getTotalCountApiInRange = async (startDate, endDate) => {
   
    try {
      const startDateFormatted = encodeURIComponent(
        moment(startDate).format("YYYY-MM-DD HH:mm:ss")
      );
      const endDateFormatted = encodeURIComponent(
        moment(endDate).format("YYYY-MM-DD HH:mm:ss")
      );
 
      const userId = localStorage.doctorId;
      setLoading(true)
      const response = await axios.get(
        `v2/admin/total_count?userId=${encodeURIComponent(userId)}&lhi=high&created_on_start=${startDateFormatted}&created_on_end=${endDateFormatted}`,
        {
          headers: { accessToken: localStorage.accessToken },
        }
      );
      setLoading(false)
 
      if (response.data.range_stats) {
        setTotal_doctors(response.data.range_stats.date_range_doctors);
        setTotal_assessments(response.data.range_stats.total_range_assessments);
        setTotal_patients(response.data.range_stats.date_range_patients);
        setHighRiskCount(response.data.range_stats.high_risk_patients_range);
      } else {
        console.log("Response data range_stats is undefined or null");
      }
    } catch (error) {
      console.log("Error fetching data:", error.message);
    } finally {
      setLoading(false)
    }
  };
 
 
  const dataList = React.useMemo(
    () => props.doctors.doctors,
    [props.doctors.doctors]
  );
  dataList.filter(function (n) {
    if (n.role === "doctor") {
      count++;
    }
  });
  const [width, setWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  const handle1Week = (filter) => {
    setActiveFilter(filter);
    let newStartdate = moment().subtract(7, "days").startOf("day").toDate();
    let newEnddate = moment().endOf("day").toDate();

    setStartDate(newStartdate);
    setEndDate(newEnddate);

    getTotalCountApiInRange(newStartdate, newEnddate);
  };

  const handle2Weeks = (filter) => {
    setActiveFilter(filter);
    let newStartdate = moment().subtract(14, "days").startOf("day").toDate();
    let newEnddate = moment().endOf("day").toDate();

    setStartDate(newStartdate);
    setEndDate(newEnddate);

    getTotalCountApiInRange(newStartdate, newEnddate);
  };

  const handle1Month = (filter) => {
    setActiveFilter(filter);
    let newStartdate = moment().subtract(1, "month").startOf("day").toDate();
    let newEnddate = moment().endOf("day").toDate();

    setStartDate(newStartdate);
    setEndDate(newEnddate);

    getTotalCountApiInRange(newStartdate, newEnddate);
  };

  const handle3Months = (filter) => {
    setActiveFilter(filter);
    let newStartdate = moment().subtract(3, "months").startOf("day").toDate();
    let newEnddate = moment().endOf("day").toDate();

    setStartDate(newStartdate);
    setEndDate(newEnddate);

    getTotalCountApiInRange(newStartdate, newEnddate);
  };
 
  const handleRangeSelected = (args) => {
    setActiveFilter(null)
    const startDate1 = args.value[0];
    const endDate1 = args.value[1];
 
    const formattedStartDate = moment(startDate1).format("YYYY-MM-DD HH:mm:ss");
    const formattedEndDate = moment(endDate1).format("YYYY-MM-DD HH:mm:ss");
 
    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);
 
    getTotalCountApiInRange(formattedStartDate, formattedEndDate);
  };
 
  return (
    <div className="dashboard">
      <div className="dashboard__content">
        {loading ? (
          <>
            <div style={{ display: "flex", gap: "20px" }}>
              <ShimmerButton />
              <ShimmerThumbnail height={38} width={250} />
              <ShimmerButton />
              <ShimmerButton />
              <ShimmerButton />
              <ShimmerButton />
            </div>
            <div
              style={{
                display: "flex",
                gap: "17px",
                marginLeft: "0px",
                marginBottom: "10px",
              }}
            >
              <ShimmerThumbnail
                height={200}
                width={400}
                className="m-0"
                rounded
              />
              <ShimmerThumbnail
                height={200}
                width={400}
                className="m-0"
                rounded
              />
              <ShimmerThumbnail
                height={200}
                width={400}
                className="m-0"
                rounded
              />
            </div>
            <ShimmerThumbnail
              height={200}
              width={400}
              className="m-0"
              rounded
            />
            <div style={{ marginTop: "10px" }}>
              <ShimmerThumbnail
                height={200}
                width={1250}
                className="m-0"
                rounded
              />
            </div>
          </>
        ) : 
        (
          <>
            <div className="filter-container">
              <h1 className="admin-heading">Admin</h1>
              <div className="date-picker-container">
                <DateRangePickerComponent
                  id="daterangepicker"
                  style={{ width: "200px" }}
                  placeholder="Select a range"
                  startDate={startDate}
                  endDate={endDate}
                  showClearButton={false}
                  onChange={handleRangeSelected}
                   format="dd/MM/yyyy"
                />
              </div>
              <ul className="admin-filters">
      <li
        className={`adminfilter ${activeFilter === '1week' ? 'active' : ''}`}
        onClick={() => handle1Week('1week')}
      >
        1week
      </li>
      <li
        className={`adminfilter ${activeFilter === '2weeks' ? 'active' : ''}`}
        onClick={() => handle2Weeks('2weeks')}
      >
        2weeks
      </li>
      <li
        className={`adminfilter ${activeFilter === '1month' ? 'active' : ''}`}
        onClick={() => handle1Month('1month')}
      >
        1month
      </li>
      <li
        className={`adminfilter ${activeFilter === '3months' ? 'active' : ''}`}
        onClick={() => handle3Months('3months')}
      >
        3months
      </li>
    </ul>
            </div>
            <div className="dashboard__adminsummary">
              <div className="card2">
                <div className="card2--info__content">
                  <p className="card2--info__title">Total Doctors</p>
                  <img src={doctorbox} alt="patients" />
                  <div style={{ display: "flex", "flex-direction": "row" }}>
                    <div
                      style={{ display: "flex", "flex-direction": "column" }}
                    >
                      <div className="card2--info__counttotal">
                        {total_doctors}
                      </div>
 
                      <div className="card2--info__descriptiontotal">
                        Doctors
                      </div>
                    </div>
                    {/* <div
                      style={{
                        display: "flex",
                        "flex-direction": "column",
                        "margin-inline-start": "2rem",
                      }}
                    >
                      <div className="card2--info__counttotal">
                        {isNaN(props.doctors.count - count)
                          ? 0
                          : props.doctors.count - count}
                      </div>
                      <div className="card2--info__descriptiontotal">
                        DH Executives
                      </div>
                    </div> */}
                  </div>
                </div>
                <p
                  className="card2--info__description"
                  style={{ color: "#46360999" }}
                ></p>
              </div>
 
              <div className="card2 card2--total-patients">
                <div className="card2--info__content">
                  <p className="card2--info__title">Total Patients</p>
                  <img src={medicalfile} alt="high risk" />
                  <p className="card2--info__count">{total_patients}</p>
                </div>
                <p
                  className="card2--info__description"
                  style={{ color: "#FFA500" }}
                >
                  This is the Total number of patients who have been scanned
                  atleast once
                </p>
              </div>
              <div className="card2 card2--assessments">
                <div className="card2--info__content">
                  <p className="card2--info__title">Assessments</p>
                  <img src={assessmentsImg} alt="assessments" />
                  <div style={{ display: "flex", "flex-direction": "row" }}>
                    <div
                      style={{ display: "flex", "flex-direction": "column" }}
                    >
                      <div className="card2--info__counttotal">
                        {total_assessments}
                      </div>
 
                      <div className="card2--info__descriptiontotal">Total</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        "flex-direction": "column",
                        "margin-inline-start": "2rem",
                      }}
                    >
                      <div className="card2--info__counttotal">
                        {yesterdayAssessments}
                      </div>
                      <div className="card2--info__descriptiontotal">
                        Yesterday
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card2 card2--high-risk">
                <div className="card2--info__content">
                  <p className="card2--info__title">Patients with Risk</p>
                  <img src={virusImg} alt="high risk" />
                  <p className="card2--info__count">{highRiskCount}</p>
                </div>
                <p
                  className="card2--info__description"
                  style={{ color: "#FFA500" }}
                >
                  Total number of patients with high LHI.
                </p>
              </div>
            </div>
            <div className="dashboard__analytics">
              <WeeklyRiskTrend />
              {loading ? (
                    <></>
                  ) : (
                    <div style={{position: 'relative', marginTop:'-420px', zIndex:'100'}}>       
                    <Popup
                      message="Hi, I am here to assist you"
                      onClose={closePopup}
                      show={showPopup}
                    /></div>
             
                  )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
 
const mapStateToProps = (state) => ({
  analytics: state.analytics,
  zipCodes: state.zipCodes.list,
  doctors: state.doctors,
  patient: state.patient,
});

export default connect(mapStateToProps, { fetchDoctors, fetchPatients,fetchAnalytics,fetchAnalyticsforadmin })(AdminDashboard);